import { FC, ReactElement } from 'react'
import possibleDialectValues from './possibleDialectValuesV1Only.json'
const exampleSentences: {
  [key in keyof typeof possibleDialectValues]?: FC<{ input?: string }>
} = {
  IN_Z: ({ input = '...' }) => (
    <>
      Ich wohne <b>{input}</b> Züri (ersetzen Sie Züri mit ihrem Wohnort)
    </>
  ),
  KOMMENWERDEN: ({ input = '...' }) => (
    <>
      Legg di warm a, susch <b>{input}</b> no chrank.
    </>
  ),
  GSIBIN: ({ input = '...' }) => (
    <>
      Wo i no chli <b>{input}</b>.
    </>
  ),
}
export default exampleSentences
